import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaTimes, FaUserPlus } from 'react-icons/fa';

const API_KEY = "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079";
const PATIENT_ADD_API = "https://api.muktihospital.com/api/patient/add";

const AddPatientModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({ name: '', phoneNumber: '', age: '' });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phoneNumber) {
      toast.warning("Name and Phone Number are required!");
      return;
    }

    setLoading(true);
    try {
      const dataToSend = new FormData();
      dataToSend.append("name", formData.name);
      dataToSend.append("phoneNumber", formData.phoneNumber);
      if (formData.age) dataToSend.append("age", formData.age);

      // Need auth token? 
      const token = localStorage.getItem("authToken");

      const res = await axios.post(PATIENT_ADD_API, dataToSend, {
        headers: { 
            "x-api-key": API_KEY,
            "Authorization": `Bearer ${token}`
        }
      });

      toast.success("Patient added successfully!");
      const newPatient = res.data.patient || res.data; 
      onSuccess(newPatient);
      
      // Reset & Close
      setFormData({ name: '', phoneNumber: '', age: '' });
      onClose();

    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || "Failed to add patient");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        
        {/* Header */}
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex justify-between items-center">
          <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <FaUserPlus className="text-blue-600" /> New Patient
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition-colors">
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Patient Name <span className='text-red-500'>*</span></label>
                <input 
                    type="text" 
                    className="w-full border rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="ex: John Doe"
                    value={formData.name}
                    onChange={e => setFormData({...formData, name: e.target.value})}
                />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number <span className='text-red-500'>*</span></label>
                    <input 
                        type="text" 
                        className="w-full border rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="017..."
                        value={formData.phoneNumber}
                        onChange={e => setFormData({...formData, phoneNumber: e.target.value})}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Age (Optional)</label>
                    <input 
                        type="text" 
                        className="w-full border rounded-lg p-2.5 outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="ex: 25 Y"
                        value={formData.age}
                        onChange={e => setFormData({...formData, age: e.target.value})}
                    />
                </div>
            </div>

            <div className="pt-2 flex justify-end gap-3">
                <button type="button" onClick={onClose} className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300">Cancel</button>
                <button 
                    type="submit" 
                    disabled={loading}
                    className="bg-blue-600 text-sm text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-all duration-200"
                >
                    {loading ? "Saving..." : "Add Patient"}
                </button>
            </div>
        </form>
      </div>
    </div>
  );
};

export default AddPatientModal;